import { getFirestore, collection, doc, getDoc } from "firebase/firestore";

const db = getFirestore();
const usersCollection = collection(db, "users");

const getUserRegulation = async (userId) => {
  const userDocRef = doc(db, "Users", userId);
  const userDoc = await getDoc(userDocRef);

  if (userDoc.exists()) {
    return {
      regulation_id: userDoc.data().regulation_id,
    };
  }
  throw new Error("User not found");
};

export { usersCollection, getUserRegulation };
